import React from 'react';
import { css } from '@emotion/css';
import { IconS24ArrowLeft24 } from '@is24/cosma-ui-icons';
import { Msg } from '@/i18n';

const styles = {
  Link: {
    textDecoration: 'none',
    color: 'inherit',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    '&:visited, &:hover, &:active': {
      textDecoration: 'none',
      color: 'inherit',
    },
    '& span': {
      color: 'inherit',
    },
  },
};

export const BackButton = () => {
  return (
    <div className='page-head-btn button-rounded button-rounded-text-default button-rounded-size-medium button-rounded-width-hug'>
      <a href='/meinkonto/overview/' className={`text ${css(styles.Link)}`}>
        <span className='with-icon font-body-medium-regular'>
          <IconS24ArrowLeft24 width={16} height={16} fill='currentColor' className='margin-right-s' />
          <Msg id='common.buttons.backToOverview' defaultMessage='Back to Overview' />
        </span>
      </a>
    </div>
  );
};
